module.exports = __webpack_public_path__ + "images/icons_v2/close-circle-filled-33738204.svg";